import { render, staticRenderFns } from "./Banner2.vue?vue&type=template&id=18e86da4&scoped=true&"
import script from "./Banner2.vue?vue&type=script&lang=js&"
export * from "./Banner2.vue?vue&type=script&lang=js&"
import style0 from "./Banner2.vue?vue&type=style&index=0&id=18e86da4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e86da4",
  null
  
)

export default component.exports